import { Modal } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import React, { createRef } from "react";
import { breakpoints } from "../../styles/breakpoints";

const styles = (theme) => ({
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    /** Usable width: respect horizontal safe areas (notch / curved edges) without double-counting padding. */
    width: "min(820px, calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px) - 8px))",
    maxWidth:
      "calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))",
    /** Dynamic viewport: avoids fixed vh/nav-bar mismatch on iOS/Android gesture nav. */
    height:
      "min(85dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)))",
    maxHeight:
      "calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))",
    paddingTop: "env(safe-area-inset-top, 0px)",
    paddingRight: "env(safe-area-inset-right, 0px)",
    paddingBottom: "env(safe-area-inset-bottom, 0px)",
    paddingLeft: "env(safe-area-inset-left, 0px)",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "calc(100vw - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))",
      minHeight:
        "min(80dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)))",
      maxHeight:
        "calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))",
    },
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    backgroundImage: `url(${process.env.REACT_APP_MEASURIT_URL}/Measureit-logo.png)`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "min(280px, 72vw)",
    backgroundColor: "rgba(240, 248, 255, 0.7)",
    backgroundBlendMode: "lighten",
    overflow: "hidden",
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    "&::-webkit-scrollbar": {
      display: "none",
      width: 0,
      height: 0,
    },
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
    },
  },
  frameRoot: {
    flex: "1 1 0%",
    minHeight: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    padding: 5,
    boxSizing: "border-box",
  },
  frame: {
    alignSelf: "center",
    width: "100%",
    maxWidth: 620,
    minWidth: 0,
    flex: "1 1 0%",
    minHeight: 0,
    maxHeight: "100%",
    border: "none",
  },
});

const MeasureItModal = (props) => {
  const frame = createRef();
  const { classes } = props;

  const handleOpen = () => {};

  const loadAddress = () => {
    frame.current.contentWindow.postMessage(
      {
        func: "options",
        args: {
          min: 1,
          max: 300000,
          isMetric: props.isMetric,
          mode: props.measurementMode,
          disableBrush: false,
        },
      },
      "*",
    );

    setTimeout(() => {
      frame.current.contentWindow.postMessage(
        {
          func: "setAddressString",
          args: {
            address: props.address,
          },
        },
        "*",
      );
    }, 1000);
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.modalOpened}
      onClose={handleOpen}
    >
      <div className={classes.paper}>
        <div className={classes.frameRoot}>
          <iframe
            className={`measurit-frame ${classes.frame}`}
            id="measureit-frame"
            onLoad={loadAddress}
            title={"measurit-frame"}
            ref={frame}
            src={process.env.REACT_APP_MEASURIT_URL}
            sandbox="allow-popups allow-top-navigation allow-scripts allow-same-origin allow-modals"
          />
        </div>
      </div>
    </Modal>
  );
};

export default withStyles(styles)(MeasureItModal);
